import { render } from "./PlanosDeTreinoFormulario.vue?vue&type=template&id=cdbb08ee&scoped=true"
import script from "./PlanosDeTreinoFormulario.vue?vue&type=script&lang=js"
export * from "./PlanosDeTreinoFormulario.vue?vue&type=script&lang=js"

import "./PlanosDeTreinoFormulario.vue?vue&type=style&index=0&id=cdbb08ee&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbb08ee"]])

export default __exports__